module.exports = __webpack_public_path__ + "static/media/Footer-Apoio.492dfb81.png";